import { useApiConfig, postJson } from '../../../composables/useApi';
import type { ApiConfig } from '../../../composables/useApi';

export const categoryApi = {
  searchWithConfig: async (api: ApiConfig, q: string) => {
    return postJson<{ data: Array<{ id:number; name:string; parent_name?: string|null }> }>(
      api.apiCategorySearch,
      { q }
    ).then(r => r.data);
  },
  search: async (q: string) => {
    const api = useApiConfig();
    return categoryApi.searchWithConfig(api, q);
  },
};
